export default __webpack_public_path__ + "static/media/first-section-1.ac38f271.png";